export const FileTypes = {
  CSV: 'CSV',
};
